import Icon from '@ant-design/icons/lib/components/Icon';
import type { GetProps } from 'antd';

const NoConnexionSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 19.5101L12.01 19.499"
        stroke="#0C2561"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 3L21 21"
        stroke="#0C2561"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 8C3.18476 7.11143 4.4475 6.39832 5.75742 5.86066M22 8C18.4276 5.32068 14.1461 4.23664 10 4.74787"
        stroke="#0C2561"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5 12C6.3333 11 7.8888 10.3333 9.51838 10M19 12C17.7314 11.0486 16.2617 10.3989 14.7183 10.0509"
        stroke="#0C2561"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.5 15.4999C10.7504 14.0999 13.2498 14.0995 15.5001 15.4999"
        stroke="#0C2561"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const NoConnexion = (props: GetProps<typeof Icon>) => {
  return <Icon component={NoConnexionSvg} {...props} />;
};
